import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propArrayShape, propBool, propFunc, } from '../../../../helpers/custom-prop-types';
import SearchCardKeyword from './SearchCardKeyword';
import SearchPickup from './SearchCardPickup';
import SearchCardTheme from './SearchCardTheme';
const SearchCard = (props) => {
    const { isLg, isMd, isPre, isXl, pickupList, pickupLoading, setIsFullScreenMode, showPreModal, themeList, themeLoading, } = props;
    return (_jsxs(_Fragment, { children: [_jsx(SearchCardKeyword, { setIsFullScreenMode: setIsFullScreenMode }), _jsx(SearchCardTheme, { themeList: themeList, themeLoading: themeLoading }), _jsx(SearchPickup, { isLg: isLg, isMd: isMd, isPre: isPre, isXl: isXl, loading: pickupLoading, professionals: pickupList, showPreModal: showPreModal }, isXl)] }));
};
SearchCard.propTypes = {
    isLg: propBool().isRequired,
    isMd: propBool().isRequired,
    isPre: propBool().isRequired,
    isXl: propBool().isRequired,
    pickupList: propArrayShape().isRequired,
    pickupLoading: propBool().isRequired,
    setIsFullScreenMode: propFunc().isRequired,
    showPreModal: propFunc().isRequired,
    themeList: propArrayShape().isRequired,
    themeLoading: propBool().isRequired,
};
export default SearchCard;
